import axios from "axios";
import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// CLIENT NEW PO CREATION APIs
// Legacy route: /Accounts/AddNewClientPO
// ==============================================

// 1. Get all Cost Centers for Client PO (GET)
export const getAllCostCentersClient = async () => {
    try {
        const response = await axios.get(
            `${API_BASE_URL}/Accounts/GetAllCostCentersclient`,
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        console.error('❌ Get All Cost Centers Client API Error:', error.response || error);
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 2. Get all Clients (GET)
export const getAllClients = async () => {
    try {
        const response = await axios.get(
            `${API_BASE_URL}/Accounts/GetAllClients`,
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        console.error('❌ Get All Clients API Error:', error.response || error);
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 3. Get Sub-Clients for a Client (GET)
export const getSubClientsByClientID = async (clientcode) => {
    try {
        const queryParams = new URLSearchParams({ clientcode });
        const response = await axios.get(
            `${API_BASE_URL}/Accounts/GetSubClientsbyClientID?${queryParams}`,
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        console.error('❌ Get Sub-Clients By Client ID API Error:', error.response || error);
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 4. Get Cost Center details for the "View CC Details" panel (GET)
export const getCCDetailsByCcCode = async (ccCode) => {
    try {
        const queryParams = new URLSearchParams({ CcCode: ccCode });
        const response = await axios.get(
            `${API_BASE_URL}/Accounts/GetCCDetailsbyCcCode?${queryParams}`,
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        console.error('❌ Get CC Details By CC Code API Error:', error.response || error);
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 5. Save the New Client PO (POST)
export const addNewClientPO = async (params) => {
    try {
        const payload = {
            pono: params.pono,
            postartdate: params.postartdate,
            pocompletiondate: params.pocompletiondate,
            total: params.total,
            povalue: params.povalue,
            gst: params.gst,
            clientid: params.clientid,
            subclientid: params.subclientid,
            Madvance: params.madvance,
            rabill: params.rabill,
            rabilldues: params.rabilldues,
            advancesettelment: params.advancesettelment,
            CostCenter: params.costCenter,
            Action: 'New',
            FyYears: '0',
            FyPercents: '0',
            FyyearAmts: '0',
            QtyVarActIn: 0,
            MinExpBasicInvVal: 0,
            UserRemarks: params.userRemarks,
            BGApplicable: params.bgApplicable,
            RoleId: params.roleId,
            Createdby: params.createdBy,
        };

        const response = await axios.post(
            `${API_BASE_URL}/Accounts/AddNewPO`,
            payload,
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        console.error('❌ Add New Client PO API Error:', error.response || error);
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};
